var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMickckc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10.0002V4.5835C13.75 2.51243 12.071 0.833496 9.99996 0.833496C7.92888 0.833496 6.24996 2.51243 6.24996 4.5835V10.0002C6.24996 12.0712 7.92888 13.7502 9.99996 13.7502C12.071 13.7502 13.75 12.0712 13.75 10.0002Z",
    fill: "#E94057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74996 8.75016C4.2102 8.75016 4.58329 9.12326 4.58329 9.5835C4.58329 12.575 7.00841 15.0002 9.99996 15.0002C12.9915 15.0002 15.4166 12.575 15.4166 9.5835C15.4166 9.12326 15.7897 8.75016 16.25 8.75016C16.7102 8.75016 17.0833 9.12326 17.0833 9.5835C17.0833 13.2136 14.3526 16.2059 10.8333 16.6183V18.3335C10.8333 18.7937 10.4602 19.1668 9.99996 19.1668C9.53972 19.1668 9.16663 18.7937 9.16663 18.3335V16.6183C5.64731 16.2059 2.91663 13.2136 2.91663 9.5835C2.91663 9.12326 3.28972 8.75016 3.74996 8.75016Z",
    fill: "#E94057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMickckc);
export default __webpack_public_path__ + "static/media/Mickckc.639cf9ab47c3e3b2a27252d15361c08d.svg";
export { ForwardRef as ReactComponent };